import React from "react";
import { Button } from "../button/Button";
import { Colors } from "../../utils/colors";
import { BorderButton } from "../borderButton/BorderButton";
import { useSelectCircleStore } from "../../stores/StoreContext";
import { observer } from "mobx-react-lite";

type props = {
  onExclude?: () => void;
  onNext?: () => void;
};

export const SelectCircleExpandedActionButtons: React.FC<props> = observer(
  ({ onExclude, onNext }) => {
    const selectCircleStore = useSelectCircleStore();
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
        }}>
        {onExclude && (
          <BorderButton
            text="Exclude"
            onPress={onExclude ?? (() => {})}
            btnStyle={{
              width: 163,
              height: 56,
              backgroundColor: "transparent",
              border: `2px solid white`,
            }}
            textStyle={{
              color: "white",
              fontWeight: 600,
              fontSize: 14,
              paddingBottom: 2,
            }}
          />
        )}
        {onNext && (
          <Button
            text="Next"
            disabled={selectCircleStore.isNextButtonDisabled}
            onPress={onNext ?? (() => {})}
            btnStyle={{
              width: 163,
              height: 56,
              backgroundColor: "white",
            }}
            textStyle={{
              color: Colors.darkBrown,
              fontWeight: 600,
              fontSize: 14,
              paddingBottom: 2,
            }}
          />
        )}
      </div>
    );
  }
);
